import HeaderSection from '../../components/home/HeaderSection';
import FooterSection from '../../components/home/FooterSection';
import CourseCard from '../../components/home/CoursesSection/CourseCard';
import { CourseFiltersDrawer, CourseSortFilterToolbar } from '../../components/courses/CourseListControls';
import { ROUTES } from '../../constants/routes';
import { useNewLaunchesCourses } from '../../hooks/useNewLaunchesCourses';
import { useCourseListFilters } from '../../hooks/useCourseListFilters';
import bannerBg from '../../assets/images/free-courses-banner-bg.png';
import bannerIllustration from '../../assets/images/new-courses-banner-illustration.png';
import bannerPlane from '../../assets/images/free-courses-banner-plane.png';

function NewCoursesPage() {
  const { courses, loading, error } = useNewLaunchesCourses();
  const {
    sort,
    setSort,
    draftFilters,
    setDraftFilters,
    showFilters,
    setShowFilters,
    showSort,
    setShowSort,
    filterOptions,
    filteredCourses,
    applyFilters,
    clearFilters,
    openFilters,
    toggleDraftList,
    setDraftClass,
  } = useCourseListFilters(courses);

  return (
    <>
      <HeaderSection />

      <section className="w-full shadow-[-2px_4px_10px_0_rgba(145,145,145,0.05)]">
        <div className="mx-auto w-full max-w-[1440px] p-px">
          <div className="relative min-h-[320px] overflow-hidden">
            <div
              className="absolute inset-0 h-[400px] bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${bannerBg})` }}
              aria-hidden
            />

            <div className="absolute inset-0 opacity-50" aria-hidden />

            <div className="relative z-10 mx-auto flex h-full min-h-[inherit] max-w-7xl items-center gap-2 py-8 sm:gap-3 sm:py-6 lg:h-[320px] lg:gap-4 lg:py-0">
              <div className="left-20 hidden shrink-0 self-end sm:block sm:h-[140px] sm:w-[136px] lg:h-[170px] lg:w-[165px]">
                <img
                  src={bannerPlane}
                  alt=""
                  className="h-full w-full object-contain object-bottom"
                  aria-hidden
                />
              </div>

              <div className="mb-6 flex-1 text-center">
                <h1 className="text-2xl font-bold leading-tight text-[#000000] sm:text-3xl lg:text-[40px] lg:leading-[1.15]">
                  Explore our CHSE Courses
                </h1>
                <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-[#000000] sm:text-[20px]">
                  Our newest course is designed to build strong concepts step by step. Perfectly
                  structured to help you score better and learn with confidence.
                </p>
              </div>

              <div className="hidden shrink-0 sm:block">
                <img
                  src={bannerIllustration}
                  alt=""
                  className="h-[140px] w-auto object-contain mix-blend-screen sm:h-[180px] lg:h-[320px]"
                  aria-hidden
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <CourseSortFilterToolbar
        breadcrumbItems={[
          { label: 'Course', path: ROUTES.HOME },
          { label: 'New Launched Courses', path: ROUTES.NEW_COURSES },
          { label: 'All', path: null },
        ]}
        sort={sort}
        setSort={setSort}
        showSort={showSort}
        setShowSort={setShowSort}
        openFilters={openFilters}
        setShowFilters={setShowFilters}
      />

      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        {loading ? (
          <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-6">
            {Array.from({ length: 6 }, (_, i) => (
              <li key={i} className="h-[480px] animate-pulse rounded-2xl bg-white/80" />
            ))}
          </ul>
        ) : error ? (
          <p className="py-12 text-center text-red-600">{error}</p>
        ) : filteredCourses.length > 0 ? (
          <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-6">
            {filteredCourses.map((course) => (
              <li key={course.id} className="h-full">
                <CourseCard course={course} hoverEnroll />
              </li>
            ))}
          </ul>
        ) : (
          <p className="py-12 text-center text-gray-500">No new courses available.</p>
        )}
      </div>

      <CourseFiltersDrawer
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        filteredCount={filteredCourses.length}
        filterOptions={filterOptions}
        draftFilters={draftFilters}
        setDraftFilters={setDraftFilters}
        toggleDraftList={toggleDraftList}
        setDraftClass={setDraftClass}
        applyFilters={applyFilters}
        clearFilters={clearFilters}
      />

      <FooterSection />
    </>
  );
}

export default NewCoursesPage;
